import { DatepickerHelper } from '@shared/validators/date-picker-form-validators';
import { Address } from "../address/address";
import { ParsedName } from "./parsed-name";

export class IndividualData{
    firstName: string;
    middleName1: string;
    middleName2: string;
    lastName: string;
    fullName: string;
    fullNameLabel: string;
    fullNameWithMiddle: string;
    formerName: ParsedName;
    dob?: Date;  // Date of Birth
    din: string; // Director Identification Number
    address: Address;
    birthCity: string;
    birthCountry: string;

    constructor(data: Partial<IndividualData> = {}) {
        this.firstName = data.firstName ?? '';
        this.middleName1 = data.middleName1 ?? '';
        this.middleName2 = data.middleName2 ?? '';
        this.lastName = data.lastName ?? '';
        this.fullName = data.fullName ?? '';
        this.fullNameLabel = this.buildFullNameWithMiddleLabel();
        this.fullNameWithMiddle = this.buildFullNameWithMiddle();
        this.formerName = data.formerName ? new ParsedName(data.formerName) : new ParsedName();
        this.din = data.din ?? '';
        this.dob = data.dob;
        this.address = data.address ? new Address(data.address) : new Address();
        this.birthCity = data.birthCity ?? '';
        this.birthCountry = data.birthCountry ?? '';
    }

    private buildFullName(): string {
      return this.buildFullNameWithMiddle();
    }

    private buildFullNameWithoutMiddle(): string {
      return this.lastName.includes(' ')
        ? `${ this.lastName }, ${ this.firstName }`.trim()
        : `${ this.firstName } ${ this.lastName }`.trim();
    }

    private buildFullNameWithMiddle(): string {
      const fullNameWithMiddleParts = this.lastName.includes(' ')
        ? [`${ this.lastName },`, this.firstName, this.middleName1, this.middleName2]
        : [this.firstName, this.middleName1, this.middleName2, this.lastName];

      return fullNameWithMiddleParts.filter(Boolean).join(' ').trim();
    }

    private buildFullNameWithMiddleLabel(): string {
      return IndividualData.buildFullNameWithMiddleLabel(this);
    }

    static buildFullNameWithMiddleLabel(individualData: IndividualData): string {
      const fullNameParts = [individualData.firstName, individualData.middleName1, individualData.middleName2, individualData.lastName];
      return fullNameParts.filter(Boolean).join(' ').trim();
    }

    static prepareToRequest(individualData: IndividualData): IndividualData {
        individualData.dob = individualData.dob ? DatepickerHelper.buildDateString(new Date(individualData.dob)) : individualData.dob;
        return individualData;
    }
}
